import { render, staticRenderFns } from "./subject-post-item.vue?vue&type=template&id=58b58631&scoped=true&"
import script from "./subject-post-item.vue?vue&type=script&lang=js&"
export * from "./subject-post-item.vue?vue&type=script&lang=js&"
import style0 from "./subject-post-item.vue?vue&type=style&index=0&id=58b58631&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b58631",
  null
  
)

export default component.exports